import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import AlertStack from "../../features/Alerts/AlertStack";
import { DebugComponent } from "../../features/Logger/debugComponent";
import AiAssistantBubble from "../common/AiAssistantBubble";

export default function AppLayout() {
  return (
    <Fragment>
      <AlertStack />
      <DebugComponent />
      <AiAssistantBubble />
      <Outlet />
    </Fragment>
  );
}
